import { removeUUID } from '../utils/string';
import { QueryClient } from 'react-query';

export type Config = {
  path?: string;
  cacheKey?: string | string[];
  onUploadProgress?: (event: any) => void;
};

export type Body = any;

export type MutationObject = {
  path?: string;
  body?: Body;
};
export enum Method {
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete'
}

export const onSuccess = async (queryClient: QueryClient, config: Config): Promise<void> => {
  if (config.cacheKey) {
    const cacheKeys = config.cacheKey.toString().split(',');
    for (const key of cacheKeys) {
      await queryClient.invalidateQueries(key);
    }
    return;
  }
  await queryClient.invalidateQueries(removeUUID(config.path));
  await queryClient.invalidateQueries(`${config.path as string}/in-sync`);
};
